export default "__VITE_ASSET__TqKSGBZy__"